import { SxStyleProp } from 'theme-ui';

export const Container: SxStyleProp = {
  'svg:not(:first-of-type)': {
    marginLeft: '8px',
  },
  width: 'fit-content',
  marginRight: ['auto !important', null],
  marginLeft: ['0 !important', 'auto'],
};

export const FilledStar: SxStyleProp = {
  fill: '#FFC10B',
};
